import React from 'react';
import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 16.934px;
  height: 18.106px;
`;

const TreeVMIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <g fill="#f2af00">
        <path
          data-name="Path 112"
          d="M4.608 1.674h7.717v1.76h1.674V1.428A1.425 1.425 0 0 0 12.575.004H4.358a1.424 1.424 0 0 0-1.423 1.424v4.27h1.673z"
        />
        <path
          data-name="Path 113"
          d="M15.51 4.108H7.63v1.674h4.7v3.521h1.674V5.782h1.26v7.716h-4.2V8.466A1.425 1.425 0 0 0 9.64 7.043H1.424A1.425 1.425 0 0 0 0 8.466v8.216a1.426 1.426 0 0 0 1.424 1.424h8.217a1.426 1.426 0 0 0 1.424-1.424v-1.51h4.445a1.426 1.426 0 0 0 1.424-1.424v-8.22a1.426 1.426 0 0 0-1.424-1.42zM5.869 9.977v3.771a1.426 1.426 0 0 0 1.424 1.424h2.1v1.26H1.674V8.716h7.717v4.782H7.543V9.977z"
        />
      </g>
    </Svg>
  );
};

export default TreeVMIcon;
